<template>
  <div
    class="modal fade"
    id="fileDownloadPop"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog download-file-pop" role="document">
      <div class="modal-content">
        <button
          type="button"
          class="close"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          <img src="@/assets/lems-v1/images/close-black-icon.svg" alt="" />
        </button>
        <div class="download-file-pop-content">
          <i>
            <img src="@/assets/lems-v1/images/download-hover.svg" alt="" />
          </i>
          <h3>Lenvio discuss with Binod.mp3</h3>
          <div class="download-type-radio">
            <div class="file-download--radio">
              <input
                type="radio"
                name="radiog_download"
                id="radio1"
                checked="true"
                class="css-checkbox"
              />
              <label for="radio1" class="css-label">
                {{ constants.LOCALE_SYSTEM_LABEL }}
              </label>
            </div>
            <div class="file-download--radio">
              <input
                type="radio"
                name="radiog_download"
                id="radio2"
                class="css-checkbox"
              />
              <label for="radio2" class="css-label">
                {{ constants.CLOUD_LABEL }}
              </label>
            </div>
          </div>
          <div class="download-file-pop-btn">
            <button class="v1-button-outline" id="downloadButton">
              {{ constants.DOWNLOAD_BUTTON }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import constants from "@/utils/en-US-Employee.json";

export default defineComponent({
  name: "DownloadFilePopup",
  data() {
    return {
      constants,
    };
  },
});
</script>
